// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3VbR6","buttons":"SendReceipts_buttons__2_eAV","email":"SendReceipts_email__1HGVo","bookApptTitle":"SendReceipts_bookApptTitle__1Esr4"};